import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input, Select } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title, Image } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Dropzone from "../../../../components/Admin/Dropzone";
import { isAuthAdmin } from "../../../../services/auth";
import { systemLogs } from "../../../../services/system_logs";

const CadastrarConsultor = (props) => {
  const [selectedFileFoto, setSelectedFileFoto] = useState("");
  const [selectedFileAssin, setSelectedFileAssin] = useState("");
  const [fotoUrl, setFotoUrl] = useState("");
  const description = useRef("");
  const [segmentos, setSegmentos] = useState([]);
  const consultor = useRef({
    nome: "",
    imagem: "",
    seg: "1",
    sexo: "",
    curriculo: "",
    video: "",
    linkedin_url: "",
    assinatura: "",
    ativo: "S",
  });
  const [assinaturaUrl, setAssinaturaUrl] = useState("");

  useEffect(() => {
    if (segmentos.length == 0) {
      loadSegmentos();
    }
  }, []);

  const loadSegmentos = async () => {
    await api.get(`/area`).then((res) => setSegmentos(res.data));
  };

  const uploadImageFoto = useCallback(async () => {
    try {
      if (!selectedFileFoto) {
        return false;
      }

      if (!consultor.current.nome) {
        swal("Erro !", "Por favor, insira o nome do consultor !", "error");
        return false;
      }

      setFotoUrl("");

      const inputData = new FormData();

      inputData.append("file", selectedFileFoto);
      inputData.append("path", "imagens-voitto/imagens-blog/meta/ctas");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      consultor.current["imagem"] = url;
      setFotoUrl(url);

      toast.success(
        "A operação de upload da imagem do consultor foi concluida com sucesso!",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );

      return true;
    } catch (err) {
      toast.error(
        "A operação de upload da imagem do consultor falhou, verifique o arquivo e tente novamente",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );

      return false;
    }
  }, [selectedFileFoto, consultor?.current?.nome]);

  const uploadImageAssin = useCallback(async () => {
    try {
      if (!selectedFileAssin) {
        return false;
      }

      if (!consultor.current.nome) {
        swal("Erro !", "Por favor, insira o nome do consultor !", "error");
        return false;
      }

      setAssinaturaUrl("");

      const formDataPayload = new FormData();

      const fileName = `${consultor.current.nome
        .replace(" de ", " De ")
        .replace(" da ", " Da ")}`;

      formDataPayload.append("file", selectedFileAssin);
      formDataPayload.append("nome", fileName);
      formDataPayload.append("path", `ftp-files/api/images/assinaturas`);
      formDataPayload.append("name_strategy", "keep_original_name");

      const response = await api.post("/upload", formDataPayload);

      setAssinaturaUrl(response.data.url);
      consultor.current["assinatura"] = response.data.url;

      toast.success(
        "A operação de upload da assinatura do consultor foi concluida com sucesso!",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );

      return true;
    } catch (err) {
      toast.error(
        "A operação de upload da assinatura do consultor falhou, verifique o arquivo e tente novamente",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );

      return false;
    }
  }, [selectedFileAssin, consultor?.current?.nome]);

  useEffect(() => {
    consultor.current["curriculo"] =
      description.current.value || description.current;
  }, [description.current]);

  const create = useCallback(async () => {
    try {
      consultor.current["curriculo"] =
        description.current.value || description.current || "";
      const consultorValidation = await yup.object().shape({
        nome: yup
          .string("Necessário que informe o nome do consultor")
          .required("Necessário que informe o nome do consultor"),
        imagem: yup
          .string("Necessário que envie a imagem do consultor")
          .required("Necessário que envie a imagem do consultor"),
        curriculo: yup
          .string("Necessário que informe o curriculo")
          .required("Necessário que informe o curriculo"),
        linkedin_url: yup
          .string("Necessário que informe o linkedin")
          .required("Necessário que informe o linkedin"),
        seg: yup
          .string("Necessário que informe o segmento")
          .required("Necessário que informe o segmento"),
        sexo: yup
          .string("Necessário que informe o sexo")
          .required("Necessário que informe o sexo"),
      });

      await consultorValidation.validate(consultor.current, {
        abortEarly: true,
      });

      const res = await api.post(`/admin/consultor`, consultor.current);

      await systemLogs(
        "consultor",
        `criou o consultor de id=${res.data.consultor.id}`
      );

      props.history.push("/admin/consultores");
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro de Validação!", err.message, "error");
        return;
      }
      swal("Erro !", "Não foi possível criar este consultor", "error");
    }
  }, [consultor.current]);

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Cadastrar Consultor</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Nome:"
                placeholder="Nome do consultor..."
                onChange={(e) => {
                  consultor.current["nome"] = e.target.value;
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <label>Foto:</label>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Dropzone onFileUploaded={setSelectedFileFoto} />
                  </div>
                  {consultor.current.nome && fotoUrl && (
                    <div
                      style={{
                        flex: "0 0 300px",
                        height: "auto",
                        minHeight: "200px",
                      }}
                    >
                      <Image
                        src={fotoUrl}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "contain",
                          border: "2px dashed #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                  )}
                </div>
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Button color="primary" onClick={() => uploadImageFoto()}>
                Subir imagem
              </Button>
            </Form.Field>
            <Form.Field>
              <label>Sexo:</label>
              <label>
                <input
                  type="radio"
                  name="sexo"
                  id="sexo"
                  onClick={(e) => (consultor.current["sexo"] = "M")}
                />
                masculino
              </label>
              <label>
                <input
                  type="radio"
                  name="sexo"
                  id="sexo"
                  onClick={(e) => (consultor.current["sexo"] = "F")}
                />
                feminino
              </label>
            </Form.Field>

            <label>Curriculo</label>
            <TextEditor
              haveFullscreen
              default={description}
              text={description}
            />
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Video:"
                placeholder="Video..."
                onChange={(e) => {
                  consultor.current["video"] = e.target.value;
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Linkedin:"
                placeholder="Linkedin link..."
                onChange={(e) => {
                  consultor.current["linkedin_url"] = e.target.value;
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <label>Assinatura:</label>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Dropzone onFileUploaded={setSelectedFileAssin} />
                  </div>
                  {consultor.current.nome && assinaturaUrl && (
                    <div
                      style={{
                        flex: "0 0 300px",
                        height: "auto",
                        minHeight: "200px",
                      }}
                    >
                      <Image
                        src={assinaturaUrl}
                        onError={(e) => {
                          if (e.target.src.includes(".jpg")) {
                            setAssinaturaUrl(
                              e.target.src.replace(".jpg", ".png")
                            );
                          }
                        }}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "contain",
                          border: "2px dashed #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                  )}
                </div>
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Button color="primary" onClick={() => uploadImageAssin()}>
                Subir assinatura
              </Button>
            </Form.Field>
            <Form.Group>
              <Form.Field control={Button} onClick={() => create()}>
                Criar
              </Form.Field>
              <Link to="/admin/consultores">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CadastrarConsultor);
